import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  public loaderSubject$ = new BehaviorSubject<boolean>(false);
  loaderState = this.loaderSubject$.asObservable();
  private requests: HttpRequest<any>[] = [];
  constructor(
    public router: Router,
    public toasterService: ToastrService,
  ) { }

  setLoader(isLoading: boolean): void {
    this.loaderSubject$.next(isLoading);
  }

  getLoader(): Observable<boolean> {
    return this.loaderState;
  }

  setRequests(url: HttpRequest<any>): void {
    this.requests.push(url);
  }

  getRequests(): any {
    this.requests;
  }

  removeHttpRequest(req: HttpRequest<any>): any {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.setLoader(this.requests.length > 0);
  }

  dateFormat(date: string, format: string): any {
    return moment(date ? date : moment()).format(format);
    //return null;
  }

  formatCurrency(currency) {
    if (currency == null || currency == undefined || isNaN(currency)) return "$0.00";
    var formatted = currency.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return "$" + `${formatted}`;
  }

  formatMonthlyIndexation(currency) {
    if (currency == null || currency == undefined || isNaN(currency)) return "$0.00";
    // Convert to string and split at decimal
    const parts = currency.toString().split('.');
    const wholeNumber = parts[0];
    const decimals = parts.length > 1 ? parts[1].substring(0, 2).padEnd(2, '0') : '00';
    
    // Format whole number with commas
    const formatted = wholeNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    
    return `$${formatted}.${decimals}`;
  }

  BuildOTG(percentCleared: number, vegetationClass: string) {
    if (vegetationClass == null) return null;
    if (percentCleared <= 0) return vegetationClass;

    var clearedText = "cleared";

    if (percentCleared >= 90) return `${vegetationClass} >= 90% ${clearedText}`;
    else if (percentCleared >= 70) return `${vegetationClass} >= 70% and < 90% ${clearedText}`;
    else if (percentCleared >= 50) return `${vegetationClass} >= 50% and < 70% ${clearedText}`;
    else return `${vegetationClass} < 50% ${clearedText}`;
  }

  BuildSpeciesOTG(commonName: string, scientificName: string) {
    return `${scientificName} (${commonName})`
  }
}
